(function () {
  if (!window.RIWAYAT || !window.RIWAYAT.cursorEnabled) return;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var cursor = document.createElement('div');
  cursor.className = 'riwayat-cursor';
  cursor.setAttribute('aria-hidden', 'true');

  var trail = document.createElement('div');
  trail.className = 'riwayat-cursor__trail';
  trail.setAttribute('aria-hidden', 'true');

  document.body.append(trail, cursor);
  document.body.classList.add('riwayat-cursor-active');

  var target = { x: -100, y: -100 };
  var cur = { x: -100, y: -100 };
  var trailPos = { x: -100, y: -100 };
  var lastMove = 0;

  document.addEventListener(
    'pointermove',
    function (e) {
      target.x = e.clientX;
      target.y = e.clientY;
      lastMove = performance.now();
      trail.style.opacity = '0.6';
    },
    { passive: true }
  );

  document.addEventListener('pointerleave', function () {
    cursor.style.opacity = '0';
    trail.style.opacity = '0';
  });

  document.addEventListener('pointerenter', function () {
    cursor.style.opacity = '1';
  });

  var buttonSelector = 'a, button, [role="button"], input[type="submit"], summary, .button';
  var imageSelector = '.riwayat-tilt, .product__media, product-media, [data-riwayat-cursor="image"]';
  var surfaceSelector = '[data-riwayat-surface]';

  document.addEventListener(
    'pointerover',
    function (e) {
      var target = e.target;
      if (!(target instanceof Element)) return;
      if (target.closest(buttonSelector)) {
        document.body.dataset.cursorMode = 'button';
      } else if (target.closest(imageSelector)) {
        document.body.dataset.cursorMode = 'image';
      } else if (target.closest(surfaceSelector)) {
        document.body.dataset.cursorMode = 'surface';
      } else {
        delete document.body.dataset.cursorMode;
      }
    },
    { passive: true }
  );

  document.addEventListener(
    'pointerdown',
    function (e) {
      var surface = e.target instanceof Element ? e.target.closest(surfaceSelector) : null;
      if (!surface || reducedMotion) return;
      var rect = surface.getBoundingClientRect();
      var ripple = document.createElement('span');
      ripple.className = 'riwayat-ripple-gold';
      ripple.style.left = e.clientX - rect.left + 'px';
      ripple.style.top = e.clientY - rect.top + 'px';
      ripple.style.width = ripple.style.height = Math.max(rect.width, rect.height) + 'px';
      surface.style.position = surface.style.position || 'relative';
      surface.style.overflow = 'hidden';
      surface.appendChild(ripple);
      ripple.addEventListener('animationend', function () {
        ripple.remove();
      });
    },
    { passive: true }
  );

  function loop() {
    var lerp = reducedMotion ? 1 : 0.35;
    var trailLerp = reducedMotion ? 1 : 0.12;

    cur.x += (target.x - cur.x) * lerp;
    cur.y += (target.y - cur.y) * lerp;
    trailPos.x += (target.x - trailPos.x) * trailLerp;
    trailPos.y += (target.y - trailPos.y) * trailLerp;

    cursor.style.transform = 'translate3d(' + cur.x + 'px,' + cur.y + 'px,0)';
    trail.style.transform = 'translate3d(' + trailPos.x + 'px,' + trailPos.y + 'px,0)';

    if (performance.now() - lastMove > 250) {
      trail.style.opacity = '0';
    }

    requestAnimationFrame(loop);
  }

  requestAnimationFrame(loop);
})();
